'use strict';

var cov_11ewsvgklc = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/components/paginator/paginator.js',
        hash = 'e34db71de1b2c96e1c1c2030cd7a1cbe1b1cd136',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/components/paginator/paginator.js',
        statementMap: {
            '0': {
                start: {
                    line: 4,
                    column: 8
                },
                end: {
                    line: 4,
                    column: 64
                }
            },
            '1': {
                start: {
                    line: 8,
                    column: 25
                },
                end: {
                    line: 8,
                    column: 65
                }
            },
            '2': {
                start: {
                    line: 9,
                    column: 8
                },
                end: {
                    line: 9,
                    column: 32
                }
            },
            '3': {
                start: {
                    line: 13,
                    column: 8
                },
                end: {
                    line: 15,
                    column: 9
                }
            },
            '4': {
                start: {
                    line: 14,
                    column: 12
                },
                end: {
                    line: 14,
                    column: 38
                }
            },
            '5': {
                start: {
                    line: 16,
                    column: 22
                },
                end: {
                    line: 16,
                    column: 47
                }
            },
            '6': {
                start: {
                    line: 17,
                    column: 8
                },
                end: {
                    line: 17,
                    column: 28
                }
            },
            '7': {
                start: {
                    line: 21,
                    column: 8
                },
                end: {
                    line: 21,
                    column: 37
                }
            },
            '8': {
                start: {
                    line: 22,
                    column: 8
                },
                end: {
                    line: 22,
                    column: 35
                }
            },
            '9': {
                start: {
                    line: 26,
                    column: 0
                },
                end: {
                    line: 34,
                    column: 7
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 3,
                        column: 4
                    },
                    end: {
                        line: 3,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 3,
                        column: 14
                    },
                    end: {
                        line: 5,
                        column: 5
                    }
                },
                line: 3
            },
            '1': {
                name: '(anonymous_1)',
                decl: {
                    start: {
                        line: 7,
                        column: 4
                    },
                    end: {
                        line: 7,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 7,
                        column: 23
                    },
                    end: {
                        line: 10,
                        column: 5
                    }
                },
                line: 7
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 12,
                        column: 4
                    },
                    end: {
                        line: 12,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 12,
                        column: 19
                    },
                    end: {
                        line: 18,
                        column: 5
                    }
                },
                line: 12
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 20,
                        column: 4
                    },
                    end: {
                        line: 20,
                        column: 5
                    }
                },
                loc: {
                    start: {
                        line: 20,
                        column: 19
                    },
                    end: {
                        line: 23,
                        column: 5
                    }
                },
                line: 20
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 4,
                        column: 24
                    },
                    end: {
                        line: 4,
                        column: 63
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 4,
                        column: 24
                    },
                    end: {
                        line: 4,
                        column: 57
                    }
                }, {
                    start: {
                        line: 4,
                        column: 61
                    },
                    end: {
                        line: 4,
                        column: 63
                    }
                }],
                line: 4
            },
            '1': {
                loc: {
                    start: {
                        line: 13,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                },
                type: 'if',
                locations: [{
                    start: {
                        line: 13,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }, {
                    start: {
                        line: 13,
                        column: 8
                    },
                    end: {
                        line: 15,
                        column: 9
                    }
                }],
                line: 13
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0,
            '7': 0,
            '8': 0,
            '9': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaginatorController = function () {
    function PaginatorController() {
        _classCallCheck(this, PaginatorController);
    }

    _createClass(PaginatorController, [{
        key: '$onInit',
        value: function $onInit() {
            cov_11ewsvgklc.f[0]++;
            cov_11ewsvgklc.s[0]++;

            this.pageSize = (cov_11ewsvgklc.b[0][0]++, this.collection.$params.page_size) || (cov_11ewsvgklc.b[0][1]++, 25);
        }
    }, {
        key: 'goToPreviousPage',
        value: function goToPreviousPage() {
            cov_11ewsvgklc.f[1]++;

            var previous = (cov_11ewsvgklc.s[1]++, Math.max(1, this.collection.$page - 1));
            cov_11ewsvgklc.s[2]++;
            this.goToPage(previous);
        }
    }, {
        key: 'goToNextPage',
        value: function goToNextPage() {
            cov_11ewsvgklc.f[2]++;
            cov_11ewsvgklc.s[3]++;

            if (!this.collection.$page) {
                cov_11ewsvgklc.b[1][0]++;
                cov_11ewsvgklc.s[4]++;

                this.collection.$page = 0;
            } else {
                cov_11ewsvgklc.b[1][1]++;
            }
            var next = (cov_11ewsvgklc.s[5]++, this.collection.$page + 1);
            cov_11ewsvgklc.s[6]++;
            this.goToPage(next);
        }
    }, {
        key: 'goToPage',
        value: function goToPage(page) {
            cov_11ewsvgklc.f[3]++;
            cov_11ewsvgklc.s[7]++;

            this.collection.$page = page;
            cov_11ewsvgklc.s[8]++;
            this.collection.$refresh();
        }
    }]);

    return PaginatorController;
}();

cov_11ewsvgklc.s[9]++;


angular.module('app').component('paginator', {
    templateUrl: 'app/components/paginator/paginator.html',
    controller: PaginatorController,
    bindings: {
        collection: '<'
    }
});